module.exports = __webpack_public_path__ + "static/media/mwe.5d2d3d91.png";